import Flickity from 'flickity';

window.addEventListener('load', function () {

	const testSlider = document.querySelector('.testimonials-slider');

	if( testSlider ) {

		var elem = document.querySelector('.testimonials-slider');
		var flkty = new Flickity( elem, {
		  pageDots: false,
		  contain:true
		});

	}

}, false);